import BasicPage from '~/mixins/simply-descriptions/';
import { Component, Vue } from 'nuxt-property-decorator';

@Component({
    mixins: [BasicPage]
})
export default class extends Vue {
    meta: Descriptions;
}
